module.exports = require("core-js/library/fn/array/is-array");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
// module id = 177
// module chunks = 0